'use strict';
namespace TR {
    class SelectedAttractionCtrl {
        private attractionsBasket: any;
        private totalPrice: number = 0;
        private totalCurrency: string = 'GBP';
        public showAttractionsInfo: boolean = true;

        constructor(private basketStore:any,
                    private attractionService:any) {
            basketStore.getAttractionsBasket().then(data => {
                const basketItems = data && data.LineItems ? data.LineItems : [];
                this.attractionsBasket = basketItems.map(item => {
                    const dates = attractionService.getLineItemDates(item);
                    const description = item.Description;
                    const specification = description && description.Specification;
                    let basketItem = {
                        title: description.Title,
                        selectedDate: dates.selected,
                        options: specification && specification.reduce(
                            (str, op) => `${str}${str?',':''} ${op.Label}: ${op.Value}`, ''),
                        specification : specification,
                        dateValidity: dates.from && dates.to
                            ? {from: dates.from, to: dates.to} : null,
                        datesMatch : dates.selected === dates.from && dates.selected === dates.to,
                        tickets: item.Tickets ? item.Tickets.map(
                            ticket => {
                                const count = parseInt(ticket.Value, 10) || 0;
                                if (0 < count) {
                                    this.totalPrice += count * ticket.Price;
                                    this.totalCurrency = ticket.Currency;
                                    return {
                                        label: ticket.Label,
                                        count: count,
                                        currency: ticket.Currency,
                                        price: ticket.Price,
                                        total: count * ticket.Price
                                    };
                                } else {
                                    return null;
                                }
                            }).filter(item => item != null) : [],
                        ticketsTotalPrice : 0
                    };
                    basketItem.ticketsTotalPrice = basketItem.tickets.reduce((total, ticket) => {
                        return total + ticket.total;
                    }, 0);
                    return basketItem;
                });
            });
        }

        getCount() : Number {
            return this.attractionsBasket.length;
        }

        toggleInfo() : void {
            this.showAttractionsInfo = !this.showAttractionsInfo;
        }

        getItems() : any {
            return this.attractionsBasket;
        }

        getTotalPrice() : number {
            return this.totalPrice;
        }

        getTotalCurrency() : string {
            return this.totalCurrency;
        }
    }

    angular
        .module('TR')
        .controller('SelectedAttraction', SelectedAttractionCtrl);
}
